import { HttpClinet, baseURL, version } from "./../utils/config";

export const authAPI = {
  Login: (data) => {
    return HttpClinet({
      url: `${baseURL}/api/${version}/user/login`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      // cancelToken:,
      data: data,
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  forgetPassword: (data) => {
    return HttpClinet({
      url: `${baseURL}/api/${version}/user/forgetPassword`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data,
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  ResetPassword: (data) => {
    return HttpClinet({
      url: `${baseURL}/api/${version}/user/ResetPassword`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data,
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  forgetPasswordByID: (id) => {
    return HttpClinet({
      url: `${baseURL}/api/${version}/user/forgetPassword/${id}`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  GetUser: () => {
    return HttpClinet({
      url: `${baseURL}/api/${version}/user/getUser`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return error;
      });
  },
  regenerate_otp: (data) => {
    return HttpClinet({
      url: `${baseURL}/api/${version}/user/regenerate_otp`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data,
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  ChangePassword: (data) => {
    return HttpClinet({
      url: `${baseURL}/api/${version}/user/ChangePassword`,
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      data,
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw error;
      });
  },
};
